import { useEffect, useState } from 'react'
import useSWR from 'swr'
import useRequestPage from './useRequestPage'

const useSWRFetchPaginationProperty = (fetcher, param, fetcherOptions, currentPage = 1, perPage = 5) => {
  const [meta, setMeta] = useState({
    total: null,
    currentPage,
    perPage,
    from: null,
    to: null,
    lastPage: null
  })

  const [data, setData] = useState([])
  const requestPage = useRequestPage(param, meta.currentPage, () => {
    setMeta((prev) => ({ ...prev, currentPage: 1 }))
  })
  const { data: dataResult, error, mutate } = useSWR([requestPage, meta.perPage, param], fetcher, fetcherOptions)

  useEffect(() => {
    if (dataResult?.meta) {
      setMeta((prev) => {
        return {
          total: dataResult.meta.total,
          currentPage: dataResult.meta.current_page,
          lastPage: dataResult.meta.last_page,
          // El tamaño de pagina lo decide quien usa el hook (el argumento
          // perPage o handler.perPage), NO la respuesta.
          //
          // Antes se adoptaba el per_page que devolvia el servidor, y como ese
          // valor forma parte de la clave de SWR, una respuesta con otro numero
          // se pisaba a si misma: volvia a pedir con el tamaño nuevo y se
          // quedaba ahi. Eso es lo que hacia el stub de per_page: 10 de los
          // fetchers cuando todavia no hay condominio.
          //
          // A este hook nadie le pide paginar en pantalla --de sus usos,
          // ninguno conecta handler.perPage a un selector: se usa para traer
          // listas completas-- asi que adoptarlo no aportaba nada y solo dejaba
          // abierta esa via.
          perPage: prev.perPage,
          to: dataResult.meta.to,
          from: dataResult.meta.from
        };
      })
    }
    if (dataResult?.data) {
      if (fetcherOptions?.ASC) {
        setData(dataResult.data.reverse())
      } else {
        setData(dataResult.data)
      }
    }
    // eslint-disable-next-line
    }, [dataResult, setData, setMeta]);

  const handleNextPage = () => { setMeta(prevs => { return { ...prevs, currentPage: prevs.currentPage + 1 } }) }

  const handlePreviousPage = () => { setMeta(prevs => { return { ...prevs, currentPage: (prevs.currentPage - 1) <= 1 ? 1 : (prevs.currentPage - 1) } }) }

  const handleGoToPage = (pageNumber) => { setMeta(prevs => { return { ...prevs, currentPage: pageNumber } }) }

  const handlePerPage = (perPageNumber) => { setMeta(prevs => { return { ...prevs, perPage: perPageNumber } }) }

  return {
    data,
    meta,
    isLoading: !error && !dataResult,
    error,
    mutate,
    handler: {
      nextPage: handleNextPage,
      previousPage: handlePreviousPage,
      goToPage: handleGoToPage,
      perPage: handlePerPage
    }
  }
}

export default useSWRFetchPaginationProperty
